import { render, staticRenderFns } from "./list-messages.vue?vue&type=template&id=551f3acd&scoped=true&lang=pug&"
import script from "./list-messages.vue?vue&type=script&lang=ts&"
export * from "./list-messages.vue?vue&type=script&lang=ts&"
import style0 from "./list-messages.vue?vue&type=style&index=0&id=551f3acd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551f3acd",
  null
  
)

export default component.exports